/* eslint-disable no-unused-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/unbound-method */
import UserPersonalInfoApi, { personalInfoCheck } from '@/api/userPersonalInfo';
import ButtonBar from '@/components/button-bar';

import type { UserVo } from '@/vo/user';
import type { SelectOptionDataType } from '@hb/finance-ui/src/types/shared';
import type { VNode } from 'vue';

import { Debounce } from '@/shared/decorators/debounce';
import { Form } from '@hb/coffee';
import {
  Component,
  Mixins,
  Prop,
  Vue,
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { MaritalStatusEnum, UpdateZyqSceneEnum, UpdateZyqSourceEnum } from '@/api/userPersonalInfo/types';
import { trimAll } from '@/shared/utils/trim';
import { VerifySceneEnum } from '@/shared/verify-credit-controller/types';
import { CONTACT_SPOUSE_RELATION_CODE, VerifyEntireTypeEnum } from '@/views_v2/verify-credit/types';
import type { VerifyStageContext } from '@/views_v2/verify-credit/types';
import { ubtSendError } from '@/shared/utils/ubt';
import { IS_PRERENDERING } from '@hb/coffee-prerender';
import { ContactFormItems } from './store';
import VerifyBasicPersonal from '../../../mixins/verify-basic-personal';
import BasicPersonalHeader from '../../basic-personal-header';
import ContactForm, { ContactFormRef } from '../../contact-form';
import type { InitFormParams, OriginContact } from './types';
import { ProfileFieldEnum } from '../exp-profile/types';

import style from './index.module.scss';

const PersonalContactsStore = namespace('personalContacts');

export interface SelectSpouseStatus {
  lockSelectedSpouse: boolean;
  disableSelectSpouse: boolean;
}

@Component({
  name: 'PersonalContacts',
})
export default class PersonalContacts extends Mixins(VerifyBasicPersonal) {
  /** 当前是否“最后一步” */
  @Prop(Boolean) readonly processIsLastVerify!: boolean;

  @Prop(String) readonly verifyScene!: VerifySceneEnum;

  @Prop(String) readonly verifyEntireType!: VerifyEntireTypeEnum;

  @Prop([String]) readonly commodityIds!: string[];

  @Prop(Object) readonly verifyStageContext!: VerifyStageContext;

  @Prop(Boolean) readonly isVerifyStageHeaderUINew!: boolean;

  @Prop(Boolean) readonly ocrAfterLoan!: boolean;

  @PersonalContactsStore.State formData!: UserVo.PersonalInfo | null;

  @PersonalContactsStore.State contactRelations!: SelectOptionDataType[];

  @PersonalContactsStore.State maritalStatus!: MaritalStatusEnum | null;

  @PersonalContactsStore.Action initFormData!: (params: InitFormParams) => Promise<void>;

  @PersonalContactsStore.Action initSelectOptions!: () => Promise<void>;

  @PersonalContactsStore.Action $updateState!: (data: Dictionary) => void;

  @PersonalContactsStore.State originContactList!: OriginContact[];

  /** 每个联系人是否选择配偶的状态：锁定配偶、禁止选择配偶 */
  private selectSpouseStatusList: SelectSpouseStatus[] = ContactFormItems.map(() => ({
    lockSelectedSpouse: false,
    disableSelectSpouse: false,
  }));

  // 底部按钮文案
  private get confirmText() {
    return this.processIsLastVerify ? '提交' : '下一步';
  }

  private async setLockSpouseInfo() {
    if (this.maritalStatus) {
      const { lockEmergency, lockUnMarried } = await personalInfoCheck(
        this.commodityIds[0],
        this.maritalStatus,
      );

      this.$emit('updateVerifyStageContext', {
        lockSpouseInfo: !!lockEmergency,
        lockNoSpouseInfo: !!lockUnMarried,
      });
    }
  }

  private initSelectSpouseStatus() {
    const selectedSpouseIndex = this.formData?.userEmergencyContacts?.findIndex(
      (item) => item.contactRelation === CONTACT_SPOUSE_RELATION_CODE
    );

    /** 若用户已填联系人，则初始化不可选两个“配偶”联系人的逻辑 */
    if (typeof selectedSpouseIndex === 'number' && selectedSpouseIndex > -1) {
      this.selectSpouseStatusList = ContactFormItems.map((_, index) => ({
        lockSelectedSpouse: false,
        disableSelectSpouse: index !== selectedSpouseIndex,
      }));
    }
  }

  private getOriginContact(idx: number): OriginContact {
    return this.originContactList[idx] || {};
  }

  /** 获取指定索引的联系人数据 */
  private getFormUpdateContact(contactIndex: number): UserVo.ContactInfo {
    const { userEmergencyContacts = [] } = this.formData || {};
    return userEmergencyContacts[contactIndex] || {
      contactName: '',
      contactNo: contactIndex,
      contactPhone: '',
      contactRelation: undefined,
    };
  }

  private getShouldMaskContactName(idx: number) {
    return (this.originContactList[idx] || {}).shouldMaskContactName;
  }

  private getShouldMaskContactPhone(idx: number) {
    return (this.originContactList[idx] || {}).shouldMaskContactPhone;
  }

  /** 为所有联系人生成各自的其他联系人上下文 */
  private get contactsGroupContextList() {
    if (!this.formData?.userEmergencyContacts?.length) return [];

    const { userEmergencyContacts } = this.formData;
    return userEmergencyContacts.map(
      (__, currentIdx) => userEmergencyContacts
        .filter((_, contactIdx) => contactIdx !== currentIdx),
    );
  }

  async mounted(): Promise<void> {
    if (!IS_PRERENDERING) {
      const { requireSpouseInfo } = this.verifyStageContext;

      await this.initSelectOptions();
      await this.initFormData({ requireSpouseInfo });
      this.initSelectSpouseStatus();
      await this.setLockSpouseInfo();

      this.$emit('ubtExposeModule');
      /** 页面初始化后，“手机号”、“关系”表单触发正确性检验 */
      this.initValidateContactInfo();
    }
  }

  private render() {
    return (
      <div class={[style.container]}>
        <BasicPersonalHeader
          isVerifyStageHeaderUINew={this.isVerifyStageHeaderUINew}
          verifyScene={this.verifyScene}
          isLoanProcess={this.verifyEntireType === VerifyEntireTypeEnum.LOAN}
          ocrAfterLoan={this.ocrAfterLoan}
        />
        <Form
          class={style.formBox}
          ref="form"
          style={{ backgroundColor: 'transparent' }}
        >
          {ContactFormItems.map(
            (title, contactIndex) => this.renderContactForm(title, contactIndex),
          )}
        </Form>
        <div class={style.buttonBox}>
          <ButtonBar
            style={this.submitBtnInTransparent ? { backgroundColor: 'transparent', boxShadow: 'none' } : null}
            confirmText={this.confirmText}
            onConfirm={this.onSubmitButtonClick}
          />
        </div>
      </div>
    );
  }

  private renderContactForm(title: string, contactIndex: number): VNode {
    const contactItem = this.getFormUpdateContact(contactIndex);
    const { requireSpouseInfo, lockSpouseInfo, lockNoSpouseInfo } = this.verifyStageContext;
    const { userEmergencyContacts } = this.formData || {};
    const selectSpouseStatus = this.selectSpouseStatusList[contactIndex];
    /** 是否禁止用户在关系表单-选择“配偶” */
    let disableSelectSpouse = lockNoSpouseInfo || selectSpouseStatus.disableSelectSpouse;
    /** 是否锁定用户在关系表单-选择“配偶”，不可变更关系 */
    let { lockSelectedSpouse } = selectSpouseStatus;

    const lockSelectSpouse = () => {
      lockSelectedSpouse = true;
      contactItem.contactRelation = CONTACT_SPOUSE_RELATION_CODE;

      if (this.formData) {
        this.formData.userEmergencyContacts[0].contactRelation = CONTACT_SPOUSE_RELATION_CODE;
      }
    };

    /** 若是锁配偶状态，则关系强制选择“配偶”关系 */
    if (this.formData && (requireSpouseInfo || lockSpouseInfo)) {
      if (userEmergencyContacts?.length === 2) {
        /**
         * 若是2个联系人都已填写过了，说明这已按照要求填写了配偶信息
         * 1. 该“配偶”的联系人，直接锁定“配偶”关系，禁止用户选择
         * 2. 其他联系人，禁止选择配偶关系
         */
        const spouseLocation = userEmergencyContacts.findIndex(
          (it) => Number(it.contactRelation) === CONTACT_SPOUSE_RELATION_CODE,
        );

        if (spouseLocation > -1) {
          lockSelectedSpouse = spouseLocation === contactIndex;
          disableSelectSpouse = spouseLocation !== contactIndex;
        } else {
          /** 若是未找到配偶，则锁定第一个联系人为配偶 */
          if (contactIndex === 0) {
            lockSelectSpouse();
          }
          disableSelectSpouse = contactIndex !== 0;
        }
      } else if (!userEmergencyContacts?.length) {
        /**
         * 若是未填写过联系人，则简单处理(不考虑已填联系人的关系):
         * 1. 第一联系人锁定为配偶关系
         * 2. 第二联系人禁止选择配偶关系
         */
        if (contactIndex === 0) {
          lockSelectSpouse();
        } else {
          disableSelectSpouse = true;
        }
      }
    }

    this.selectSpouseStatusList[contactIndex] = {
      lockSelectedSpouse,
      disableSelectSpouse,
    };

    return (
      <ContactForm
        ref={`contactForm${contactIndex}`}
        contactItem={contactItem}
        contextOtherContacts={this.contactsGroupContextList[contactIndex] || []}
        lockSelectedSpouse={this.selectSpouseStatusList[contactIndex].lockSelectedSpouse}
        disableSelectSpouse={this.selectSpouseStatusList[contactIndex].disableSelectSpouse}
        showMaskContactName={this.getShouldMaskContactName(contactIndex)}
        showMaskContactPhone={this.getShouldMaskContactPhone(contactIndex)}
        validateMaskContactPhone={true}
        onChange={this.onEmergencyFieldChange.bind(this, contactIndex)}
      >
        <p class={style.contactItemTitle}>{title}</p>
      </ContactForm>
    );
  }

  /**
   * @param isImport 是否为导入操作，默认值为fasle
   */
  private onEmergencyFieldChange(
    idx: number,
    fieldName: keyof UserVo.ContactInfo,
    fieldValue: string,
    isImport = false,
  ): void {
    const { userEmergencyContacts = [] } = this.formData || {};
    let fieldNameValue = fieldValue;

    // 处理联系人姓名脱敏
    if (fieldName === 'contactName' && this.getShouldMaskContactName(idx)) {
      // 如果是导入操作，保留导入的值；如果是手动输入，清空值
      if (!isImport) {
        fieldNameValue = '';
      }

      this.originContactList.splice(idx, 1, {
        ...this.originContactList[idx],
        shouldMaskContactName: false,
      });

      this.$updateState({ originContactList: this.originContactList });
    }

    /** 更新联系人手机号是否脱敏 */
    if (fieldName === 'contactPhone' && this.getShouldMaskContactPhone(idx)) {
      // 如果是导入操作，保留导入的值；如果是手动输入，清空值
      if (!isImport) {
        fieldNameValue = '';
      }

      this.originContactList.splice(idx, 1, {
        ...this.originContactList[idx],
        shouldMaskContactPhone: false,
      });

      this.$updateState({ originContactList: this.originContactList });
    }

    /**
     * 产品需求：多联系人中仅能选填一位配偶
     * 当前联系人关系发生变化时，触发另外一个联系人关系校验
     * 在Vue.nextTick后触发"关系"的检验和处理，保证此时表单数据已完成更新
     */
    if (fieldName === 'contactRelation') {
      this.$nextTick(() => {
        const currentSelectRelation = Number(fieldValue);
        ContactFormItems.forEach((_, itemIndex) => {
          const contactFormRef = this.$refs[`contactForm${itemIndex}`] as ContactFormRef;
          /**
           * 多联系人场景下，只能有一个联系人选择配偶-实际逻辑：
           * 1. 若另一个联系人已选择关系，则检验关系的正确性 && 禁止该联系人选择”配偶“关系
           * 2. 若另一个联系人未选择关系，则禁止该联系人选择”配偶“关系
           */
          try {
            if (itemIndex === idx) return;

            const otherContactRelation = contactFormRef.getContactFormData().contactRelation;

            if (otherContactRelation) {
              contactFormRef.checkAssignFieldValidator(ProfileFieldEnum.CONTACT_RELATION);
            }

            const originList = this.selectSpouseStatusList;

            if (
              currentSelectRelation === CONTACT_SPOUSE_RELATION_CODE
              && Number(otherContactRelation) !== CONTACT_SPOUSE_RELATION_CODE) {
              /** 若当前联系人选择配偶，且另一个联系人未选择配偶，则禁止另一个联系人选择配偶 */
              this.selectSpouseStatusList = originList.map((item, ssIndex) => (ssIndex !== idx
                ? { ...item, disableSelectSpouse: true }
                : item));
            } else if (
              currentSelectRelation !== CONTACT_SPOUSE_RELATION_CODE
              && Number(otherContactRelation) !== CONTACT_SPOUSE_RELATION_CODE) {
              /** 若当前联系人未选配偶，且另一个联系人未选择配偶，则放开联系人选择配偶 */
              this.selectSpouseStatusList = originList.map((item) => ({
                ...item,
                disableSelectSpouse: false,
              }));
            }
          } catch (error) {
            ubtSendError(error as Error);
          }
        });
      });
    }

    userEmergencyContacts[idx] = {
      ...(userEmergencyContacts[idx] || {}),
      contactNo: idx,
      [fieldName]: fieldNameValue,
    };

    this.$updateState({
      formData: {
        ...this.formData,
        userEmergencyContacts,
      },
    });
  }

  private initValidateContactInfo() {
    /** 在Vue.nextTick后触发"手机号"、"关系"的检验，保证此时表单dom渲染更新已完成 */
    Vue.nextTick(() => {
      this.validateSavedContactInfo();
    });
  }

  /** 验证已保存的联系人“手机号、关系”的正确性 */
  private async validateSavedContactInfo(): Promise<boolean> {
    try {
      const getValidationField = (field: ProfileFieldEnum) => ContactFormItems.map(async (_, i) => {
        const contactFormRef = this.$refs[`contactForm${i}`] as ContactFormRef;

        if (contactFormRef
            && contactFormRef.getContactFormData()[field as keyof UserVo.ContactInfo]) {
          return contactFormRef.checkAssignFieldValidator(field);
        }

        return true;
      });

      const results = await Promise.all([
        ...getValidationField(ProfileFieldEnum.CONTACT_PHONE),
        ...getValidationField(ProfileFieldEnum.CONTACT_RELATION),
      ]);

      return results.every((res) => res);
    } catch (err) {
      ubtSendError(err as Error);

      return true;
    }
  }

  /** 检验联系人表单是否通过 */
  private async validatePassedContactForms(): Promise<boolean> {
    try {
      const validationPromises = ContactFormItems.map(async (_, i) => {
        const contactFormRef = this.$refs[`contactForm${i}`] as ContactFormRef;

        if (contactFormRef && typeof contactFormRef.checkFormValidator === 'function') {
          return contactFormRef.checkFormValidator();
        }
        /** 异常情况，默认通过检验 */
        return true;
      });

      const results = await Promise.all(validationPromises);

      return results.every((res) => res);
    } catch (err) {
      ubtSendError(err as Error);

      return true;
    }
  }

  @Debounce(200)
  private onSubmitButtonClick() {
    this.onSubmit();
  }

  private async onSubmit(): Promise<void> {
    this.$emit('ubtClickSubmit');

    if (await this.checkPreVerifySubmitState(this.verifyScene)) {
      /** 检验联系人表单正确性 */
      const isValidationPassed = await this.validatePassedContactForms();

      if (!isValidationPassed) return;

      if (this.formData && this.submitBtnInLoading === false) {
        this.submitBtnInLoading = true;

        const { userEmergencyContacts } = this.formData;
        try {
          const data: Dictionary = {
            ...this.formData,
            userEmergencyContacts: userEmergencyContacts.map((item, idx) => ({
              ...item,
              contactName: this.getShouldMaskContactName(idx)
                ? this.getOriginContact(idx).defalutContactName
                : trimAll(item.contactName),
              contactPhone: this.getShouldMaskContactPhone(idx)
                ? this.getOriginContact(idx).defalutContactPhone
                : trimAll(item.contactPhone),
            })),
          };

          await UserPersonalInfoApi.updateZYQ({
            ...(data as unknown as UserVo.PersonalInfo),
            updateSource: UpdateZyqSourceEnum.HOME_PAGE,
            updateScene: UpdateZyqSceneEnum.ONLY_CONTACTS,
          });

          // 根据当前场景，与后端交互
          this.$emit('resolveProcessVerify');
        } catch (error) {
          ubtSendError(error as Error);
        } finally {
          this.submitBtnInLoading = false;
        }
      }
    }
  }
}
